import React from "react";
import { Skeleton } from "@material-ui/lab";

class InnerHeaderSuspense extends React.Component {
    render() {
        return(
            <div className="InnerHeaderParent">
                <div className="InnerHeader InnerHeaderText" style={{backgroundPosition: `right`, backgroundSize: `contain`, backgroundRepeat: `no-repeat`, height: `737px`}}>
                    <Skeleton variant="rectangular" style={{float:`right`}} width="70%" height="100%" />
                    <div className="container h-100">
                        <div className="row h-100 align-items-center justify-content-start">
                            <div className="col-xl-12">
                                <div className="d-none d-sm-block">
                                    <Skeleton variant="text" width={400} height={180} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-block d-sm-none InnerHeaderText">
                    <Skeleton variant="text" width={350} height={100} />
                </div>
            </div>
        );
    }
}

export default InnerHeaderSuspense;